<template>
	<div class="content-i">
		<div class="content-box">
			<matches :filter="$route.query" />
		</div>
		<div class="content-panel compact">
			<div class="content-panel-close" v-on:click="controlPanel()">
				<i class="os-icon os-icon-close"></i>
			</div>

            <sports />

		</div>

	</div>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
    import filterGenerator from '@/components/form/filter';
    import matches from '@/components/stats/matches';
    import trendWidget from '@/components/user/bets/widget/trends'
    import sports from '@/components/stats/widget/sports';

    export default {
        name: 'fixture',
        components: { sports, filterGenerator,matches,trendWidget },

        data () {
            return {
                app: this.$root.app,
                filter: [],
                msg: '',
                t: this.$root.t,
                filter: {},
                sports: [],
                competitions: [],
                regions: [],
                status: []
            }
        },
        watch: {
            accessToken () {
                this.getUserSession();
                this.getWs();
            },
	        status () {
                this.filterFixture()
	        }
        },
        mounted () {
            this.fetchFixtureStatus();

        },
        methods: {
            onChangePage (page) {
                this.pagination.current = page;
                this.filter.page = page;
                var upc = this.$route.query.upcoming;
                this.$router.push({});
                this.$router.query.push({ page: page });
                window.scroll(0, 0);
            },
            filterFixture () {
                this.filter = {
                    model: {
                        page: 1,
                        match: '',
                        competitor: [],
                        startDate: '',
                        endDate: '',
                        sport: [],
                        region: [],
                        competition: [],
                        competitor: null,
                        result: [],
                        allTime: 0,
                        onLive: null
                    },
                    schema: {
                        fields: [
                            {
                                type: "Datepicker",
                                class: 'test',
                                label: this.t.start_date,
                                model: "startDate",
                                readonly: false,
                                featured: false,
                                disabled: false,
                                options: {
                                    not_before: null,
                                    clearable: true,
                                    range: true,
                                    firstDay: 1,
                                    format: 'YYYY-MM-DD',
                                    dataFormat: 'YYYY-MM-DD',
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: this.t.match_id,
                                model: "match",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "competitor",
	                              subType: 'competitor',
                                label: this.t.team_or_player,
                                model: "competitor",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "competitor",
                                subType: 'sport',
                                label: this.t.sport.title,
                                model: "sport",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "competitor",
                                subType: 'region',
                                label: this.t.region.title,
                                model: "region",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "competitor",
                                subType: 'competition',
	                              name: 'competitions',
                                label: this.t.competition.title,
                                model: "competition",
                                multi: true,
                                required: false,
                                multiSelect: true,
                                values: this.competitions,
                            },
                            {
                                type: "choices",
                                label: this.t.process_type,
                                model: "result",
                                multi: true,
                                required: false,
                                multiSelect: true,
                                values: this.status,
                                options: {
                                    value: "extendedId",
                                    name: "name"
                                }
                            },
                            {
                                type: "switch",
                                label: this.t.all_time,
                                model: "allTime",
                                multi: true,
                                readonly: false,
                                featured: false,
                                disabled: false,
                                default: true
                            },
                            {
                                type: "switch",
                                label: this.t.running,
                                model: "onLive",
                                multi: true,
                                readonly: false,
                                featured: false,
                                disabled: false,
                                default: true
                            },
                            {
                              type: "switch",
                              label: 'Reviewable',
                              model: "reviewable",
                              multi: true,
                              readonly: false,
                              featured: false,
                              disabled: false,
                              default: true
                            },
                            {
                                type: "submit",
                                label: "",
                                buttonText: "Filtrele",
                                onSubmit: this.filterNow,
                                validateBeforeSubmit: false,
                            }
                        ]
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            filterNow: function() {
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            fetchFixtureStatus () {

                this.$http.get(bsapi+'api/v1/fixture/status').then(response => {

                    this.status = response.body;
                }, response => {

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.filter-area {
		padding: 5px 20px 5px 20px;
		box-shadow: inset 10px 10px 20px -10px rgba(0,0,0,0.21);
		min-height: 100%;
		float: left;
		width: 20%;
		background-color: #f6f7f8;
	}
	.fixture-area {
		padding: 20px 20px;
		min-height: 100%;
		float: right;
		width: 80%;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/fixture.vue